import axios from 'axios';

const getLockboxPhotoByRets = async (retsId: string) => {
  const data = await axios.get(`/external/rets/${retsId}/lockbox_photo`);

  return data;
};

export default getLockboxPhotoByRets;
